import React, { useState } from "react";

import Sidebar from "../components/BuyersGuide/SideBar";
import Header from "../components/BuyersGuide/Header";
import styles from '../styles/pages/BuyersGuide.module.css'
import useWindowDimensions from "../helpers/useWindowDimensions";

const drawerWidth = 258;

const BuyersGuide = ({ children, routes }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const {width} = useWindowDimensions();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };


  return (
    <div>
      
      <Sidebar
        routes={routes}
        PaperProps={{ style: { width: drawerWidth, position: 'unset' } }}
        isMobile={width && width < 1000 ? true : false}
        open={mobileOpen}
        onClose={handleDrawerToggle}
      />

      <div className={`${styles.buyers_guide_header} ${width && width < 1000 ? styles.buyers_guide_page_mobile : ''}`}>
        <Header onDrawerToggle={handleDrawerToggle}/>
      </div>
      
      <div  className={`${styles.buyers_guide_page} ${width && width < 1000 ? styles.buyers_guide_page_mobile : ''}`}>
        {children}
      </div>
     
    </div>
  );
};

export default (BuyersGuide);
